import { Search, WhatsApp } from "@mui/icons-material";
import '../../styles/ahbaab/ProductStyle.css';
import { Box, Button } from "@mui/material";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react"; // ✅ added useEffect
import Header from "../../common/ahbaab/Header/Header";
import Footer from "../../common/ahbaab/Footer/Footer";
import polygon from '../../assest/ahbaab/Cleanroom Products.jpg';
import OurProductData from "../../data/ahbaab/OurProductData";
import { FaSquareArrowUpRight } from "react-icons/fa6";
import ErrorPage from "./ErrorPage";

const ProductsByCategory = () => {
  const { linkTag } = useParams();
  const navigate = useNavigate();

  const [searchTerm, setSearchTerm] = useState('');
  const [activeSub, setActiveSub] = useState("all");

  const selectedCategory = OurProductData.find(item => item.linkTag === linkTag);

  // ✅ Fix: reset subcategory + search when linkTag changes
  useEffect(() => {
    setActiveSub("all");
    setSearchTerm("");
  }, [linkTag]);

  if (!selectedCategory) {
    return <div style={{ textAlign: 'center' }}><ErrorPage /></div>;
  }

  const subCategories = selectedCategory.category || [];

  const filteredProducts =
    activeSub === "all"
      ? subCategories.flatMap(sub => sub.productCategory || [])
      : (subCategories.find(sc => sc.categoryLink === activeSub)?.productCategory || []);

  const searchFiltered = filteredProducts.filter(prod =>
    prod.productCategoryName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      <Header />

      <Box className='Aboutus_topdiv'>
        <img src={polygon} alt="Banner" />
        <div className="hosp_aboutushead">
          <h1>{selectedCategory.heading}</h1>
        </div>
      </Box>

      <Box>
        <div className="celebrity-filtration-div">
          {/* Left Sidebar */}
          <div className="leftsidediv col-sm-3">
            <div className="filterdiv">
              <h5>Category</h5>
            </div>
            <div className="input-group">
              <input
                type="text"
                className="form-control"
                placeholder="Search Products"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <span className="input-group-text"><Search /></span>
            </div>

            <div className="city-div">
              <div onClick={() => navigate("/products")} className="clickdiv">
                <h6>All Categories</h6>
              </div>
              <ul className="category-list">
                {OurProductData.map((item) => (
                  <li
                    key={item.linkTag}
                    onClick={() => navigate(`/products/${item.linkTag}`)}
                    className={item.linkTag === selectedCategory.linkTag ? "active-category" : ""}
                  >
                    {item.heading}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Right Side */}
          <div className="rightsidediv col-sm-9">
            {/* Subcategory Tabs */}
            <div className="subcategory-tabs d-flex flex-wrap gap-2">
              <Button
                variant={activeSub === "all" ? "contained" : "outlined"}
                onClick={() => setActiveSub("all")}
              >
                All
              </Button>
              {subCategories.map((sub) => (
                <Button
                  key={sub.categoryId}
                  variant={activeSub === sub.categoryLink ? "contained" : "outlined"}
                  onClick={() => setActiveSub(sub.categoryLink)}
                >
                  {sub.categoryName}
                </Button>
              ))}
            </div>

            {/* Products */}
            <div className="d-flex flex-wrap justify-content-center">
              {searchFiltered?.length > 0 ? (
                searchFiltered.map((prod, i) => (
                  <div key={i} className="card-box">
                    <Link to={`/products/${linkTag}/${prod.productCategoryLink}`}>
                      <div className="card-img-div1">
                        <img src={prod.productCategoryImge} alt={prod.productCategoryName} />
                        <h6>{prod.productCategoryName}</h6>
                      </div>
                    </Link>

                    {/* <div className="card-content-div">
                      <Link to={`/products/${linkTag}/${prod.productCategoryLink}`}>
                        <Button>
                          View More <FaSquareArrowUpRight className="iconbtnb" />
                        </Button>
                      </Link>
                      <Link to="https://wa.me/918448783350?text=Hi">
                        <Button>
                          WhatsApp <WhatsApp className="iconbtnb" />
                        </Button>
                      </Link>
                    </div> */}

                  </div>
                ))
              ) : (
                <p>No products found</p>
              )}
            </div>
          </div>
        </div>
      </Box>

      <Footer />
    </>
  );
};

export default ProductsByCategory;
